declare global {
  interface Window {
    __APP_CONFIG__?: { API_URL?: string };
  }
}

const raw = window.__APP_CONFIG__ ?? {};
if (!raw.API_URL) {
  throw new Error(
    "Runtime config missing: window.__APP_CONFIG__.API_URL. /config.js failed to load or is malformed.",
  );
}

export const config = {
  API_URL: raw.API_URL,
} as const;
